import { useState, useCallback } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Link, Popover, TableRow, Checkbox, MenuList, MenuItem, menuItemClasses, TableCell, IconButton, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Business } from '../../../types/UserTypes';
import { Iconify } from '../../../core/iconify';
import { paths } from '../../../../utils/paths';
import { BVTConstants } from '../../../../utils/BVTConstants';

type BusinessTableRowProps = {
  row: Business;
};

export function TableRowBusiness({ row }: BusinessTableRowProps) {
  const navigate = useNavigate();
  const [openPopover, setOpenPopover] = useState<HTMLButtonElement | null>(null);

  const handleOpenPopover = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenPopover(event.currentTarget);
  }, []);

  const handleClosePopover = useCallback(() => {
    setOpenPopover(null);
  }, []);
  
  const handleClick = () => {
    navigate(paths.admin.viewUser, { 
      state: { userId: row.userId } 
    });
  };

  const getStatusColor = (status: string) => {
    switch (status.toUpperCase()) {
      case BVTConstants.ACTIVE: return 'success';
      case BVTConstants.INACTIVE: return 'warning';
      default: return 'default';
    }
  };

  return (
    <>
      <TableRow 
        hover 
        onClick={handleClick}
        sx={{ 
          cursor: 'pointer',
          transition: 'background-color 0.2s',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        <TableCell>{row.displayName}</TableCell>
        <TableCell>{row.businessABN}</TableCell>
        <TableCell>{row.agentCompanyName}</TableCell>
        <TableCell>{row.contact}</TableCell>
        <TableCell>{row.createdAt}</TableCell>
        <TableCell align="center">
          <Chip 
            label={row.status}
            color={getStatusColor(row.status)}
            size="small"
          />
        </TableCell>
      </TableRow>

      <Popover
        open={!!openPopover}
        anchorEl={openPopover}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList
          disablePadding
          sx={{
            p: 0.5,
            gap: 0.5,
            width: 170,
            display: 'flex',
            flexDirection: 'column',
            [`& .${menuItemClasses.root}`]: {
              px: 1,
              gap: 2,
              borderRadius: 0.75,
              [`&.${menuItemClasses.selected}`]: { bgcolor: 'action.selected' },
            },
          }}
        >

          <MenuItem onClick={handleClosePopover}>
            <Iconify icon="solar:user-check-rounded-bold" />
              Update Agent
          </MenuItem>

          <MenuItem onClick={handleClosePopover} sx={{ color: 'error.main' }}>
            <Iconify icon="solar:archive-check-bold" />
            Deactivate
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
}
